"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingRoleEnum = void 0;
/** Роль участника митинга */
var MeetingRoleEnum;
(function (MeetingRoleEnum) {
  /** Наблюдатель, человек которого не видно в митинге но он всё видит и слышит */
  MeetingRoleEnum["observer"] = "observer";
  /** Организатор/владелец митинга */
  MeetingRoleEnum["owner"] = "owner";
  /** Участник, у него есть возможность передавать видео и аудио */
  MeetingRoleEnum["participant"] = "participant";
  /** Участник митинга который не имеет права вещать (его камера и аудио не передают данные) */
  MeetingRoleEnum["watcher"] = "watcher";
  /** Резервирование участия на период оплаты */
  MeetingRoleEnum["reservation"] = "reservation";
  /** Потенциальный участник, ожидающий освобождения резерва */
  MeetingRoleEnum["waiter"] = "waiter";
  /** Вышедший/отказавшийся по разным причинам */
  MeetingRoleEnum["left"] = "left";
})(MeetingRoleEnum = exports.MeetingRoleEnum || (exports.MeetingRoleEnum = {}));
